import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Navbar from "../../Navbar/Navbar";
import Footer from "../../Footer/Footer";
import "./caroussel.css";
import "./carousselMedia.css"
import { projectsImages, imageMap } from "./utils/importImages";

const ProjectGallery = () => {
  const { projectId } = useParams();
  const navigate = useNavigate();
  
  const images = projectsImages[projectId] || [];
  const [currentImage, setCurrentImage] = useState(0);

  const nextImage = () => {
    setCurrentImage((prev) => (prev === images.length - 1 ? 0 : prev + 1));
  };

  const prevImage = () => {
    setCurrentImage((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };

  if (images.length === 0) {
    return (
      <div className="caroussel-page">
        <div className="overlay-dark"></div>
        <Navbar />
        <div className="caroussel-container">
          <div style={{ color: 'white', textAlign: 'center', marginTop: '20%' }}>
            <h2>Proyecto no encontrado</h2>
            <button onClick={() => navigate(-1)} className="ver-imagenes-btn">
              <span>Volver</span>
            </button>
          </div>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="caroussel-page gallery-page">
      <div
        className="background-container-caroussel"
        style={{ backgroundImage: `url(${images[currentImage]})` }}
      ></div>
      <div className="overlay-dark"></div>
      <Navbar />

      <div className="caroussel-container">
        <div className="caroussel-content">
          <div className="text-content">
            <h1 className="caroussel-title">{imageMap[projectId] || 'Galería del Proyecto'}</h1>
            
            <div className="gallery-back-btn">
              <button onClick={() => navigate(-1)} className="ver-imagenes-btn">
                <span>Volver</span>
              </button>
            </div>
          </div>

          <div className="btn-right">
            <div 
              className="image-preview"
              style={{ backgroundImage: `url(${images[currentImage]})` }}
            >
              <div className="preview-overlay">
                <span className="image-counter">
                  {currentImage + 1} / {images.length}
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="caroussel-controls">
          <div className="navigation-buttons">
            <button className="nav-btn" onClick={prevImage}>&lt;</button>
            <button className="nav-btn" onClick={nextImage}>&gt;</button>
          </div>
          
          <div className="caroussel-indicator">
            <div className="indicator-container">
              {images.map((_, index) => (
                <div
                  key={index}
                  className={`indicator-dot ${currentImage === index ? 'active' : ''}`}
                  onClick={() => setCurrentImage(index)}
                />
              ))}
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default ProjectGallery;